// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + {"284":"eruda-lib","859":"photoswipe-lib"}[chunkId] + "." + {"284":"cb8b8199","859":"4e8b0762"}[chunkId] + ".js";
};